module.exports = __webpack_public_path__ + "static/img/JN2E3901-1080p.4409fbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio4/JN2E3901-1080p.jpg
// module id = XWOn
// module chunks = 0